<div class="dashboard-container">
  @if (isLoading()) {
    <app-dashboard-container-skeleton />
  } @else {
    <p-tabs
      [value]="activeTabIndex"
      (valueChange)="activeTabIndex = +$event"
      [scrollable]="true"
    >
      <p-tablist>
        @for (tab of tabs(); track tab.value) {
          <p-tab [value]="tab.value" [disabled]="tab.disabled">
            {{ tab.label }}
            @if (tab.badge) {
              <p-badge
                [value]="tab.badge.label"
                [severity]="tab.badge.severity"
              />
            }
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (tab of tabs(); track tab.value) {
          <p-tabpanel [value]="tab.value">
            @switch (tab.component) {
              @case ("dashboard") {
                <app-legacy-dashboard
                  [inputSiteId]="siteId"
                  [inputToken]="embeddedMode ? inputToken : null"
                  [embeddedMode]="embeddedMode"
                />
              }
              @case ("revenue") {
                @if (!analyticsStatus()?.isAnalyticsEnabled) {
                  <app-analytics-setup-required />
                } @else {
                  <app-revenue-dashboard
                    [active]="activeTabIndex === tab.value"
                    [lastIngestedOrder]="
                      analyticsStatus()?.lastIngestedOrder ?? null
                    "
                    [inputSiteId]="siteId"
                    [inputToken]="embeddedMode ? inputToken : null"
                    [embeddedMode]="embeddedMode"
                  />
                }
              }
              @case ("scheduled-orders") {
                <div class="tab-content">
                  <p>Scheduled Orders (Coming soon)</p>
                </div>
              }
              @case ("errors") {
                <div class="tab-content">
                  <p>Errors (Coming soon)</p>
                </div>
              }
            }
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  }
</div>
